import type React from "react";
import { useState } from "react";
import "../styles/TwoFAVerification.css";
import "../styles/LoginForm.css";

interface TwoFAVerificationProps {
  onVerify: (code: string) => void;
  onResend?: () => void;
  onCantLogin?: () => void;
  twoFAError?: string | null;
  isLoading: boolean;
}

const TwoFAVerification: React.FC<TwoFAVerificationProps> = ({
  onVerify,
  onResend,
  onCantLogin,
  twoFAError,
  isLoading,
}) => {
  const [code, setCode] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.length === 6) onVerify(code);
  };

  return (
    <div className="container">
      <h2 className="title">Login authentication</h2>
      {twoFAError && (
        <div
          className="login-error"
          style={{ color: "red", marginBottom: 12, textAlign: "center" }}
        >
          {twoFAError === "Login failed - no bearer token received"
            ? "Invalid code. Please try again"
            : ""}
        </div>
      )}
      <p className="description">
        We sent you a message containing a 6-digit authentication passcode. Please, open it on your
        device and enter the passcode below.
      </p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="code" className="label">
          6-digit authentication passcode
        </label>
        <input
          style={{
            marginBottom: "20px",
          }}
          inputMode="numeric"
          pattern="\d{6}"
          maxLength={6}
          name="code"
          className="input"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />

        <button
          type="submit"
          className={`button ${isLoading ? "buttonDisabled" : ""}`}
          disabled={isLoading}
        >
          {"Verify"}
        </button>
      </form>

      <div className="footer">
        <button type="button" onClick={onResend} className="link">
          Resend passcode
        </button>
        <button type="button" onClick={onCantLogin} className="link">
          I can't log in
        </button>
      </div>
    </div>
  );
};

export default TwoFAVerification;
